import { CollectionName, CollectionVisibility } from "../registry/collection-registry"
import type { CollectionCreateSchema } from "../types/typesense"

export const itemHistorySchema: CollectionCreateSchema = {
  name: CollectionName.ItemHistory,
  enable_nested_fields: true,
  fields: [
    {
      name: "id",
      type: "string",
      sort: true,
      infix: true,
    },
    {
      name: "item_id",
      type: "int32",
      sort: true,
    },
    {
      name: "operation",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
    {
      name: "list_code",
      type: "string",
      sort: true,
      infix: true,
    },
    {
      name: "item_code",
      type: "string",
      sort: true,
      infix: true,
    },
    {
      name: "item_name",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
    {
      name: "un_code",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
    {
      name: "effective_start_date",
      type: "int64",
      sort: true,
    },
    {
      name: "effective_end_date",
      type: "int64",
      optional: true,
      sort: true,
    },
    {
      name: "updated_at",
      type: "int64",
      sort: true,
    },
    {
      name: "updated_by",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
  ],
  visibility: CollectionVisibility.Public,
}
